import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: '/',
    name: 'admin',
    meta: { title: '管理控制台', login: false, componentName: 'MbBase' },
    component: () => import('@/views/mb/MbBase.vue')
  }
] as RouteRecordRaw[]
